import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { BrandingService } from '../../../../common/branding/branding.service';

@Component({
  selector: 'mars-hero',
  imports: [TranslocoPipe],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
})
export class HeroComponent {
  protected readonly branding = inject(BrandingService);
}
